module.exports = __webpack_public_path__ + "static/forte_main_5-451f03ca16c52ef51b286bdb14e71285.png";